<template>
  <div class="login">
    <form @submit.prevent="login" class="login__card">
      <h2>Kirjaudu sisään</h2>
      <base-input
        type="text"
        name="email"
        label="Sähköpostiosoite"
        v-model="email"
        :errors="errors.email"
      />
      <base-input
        type="password"
        name="password"
        label="Salasana"
        v-model="password"
        :errors="errors.password"
      />
      <button type="submit" class="button button__rounded button__submit">
        <span v-if="loading">Kirjaudutaan...</span>
        <span v-else>Kirjaudu sisään</span>
      </button>
    </form>
  </div>
</template>

<script>
import firebase from "firebase";
import { validateField, validateEmail } from "@/validation";

import BaseInput from "@/components/BaseInput";

export default {
  name: "Login",
  components: {
    BaseInput
  },
  data() {
    return {
      email: null,
      password: null,
      errors: {},
      valid: true,
      loading: false
    };
  },
  methods: {
    validateLogin() {
      this.errors = {};
      this.valid = true;

      const validEmail = validateEmail(this.email);
      this.errors.email = validEmail.error;
      if (this.valid) {
        this.valid = validEmail.valid;
      }

      const validPassword = validateField(this.password);
      this.errors.password = validPassword.error;
      if (this.valid) {
        this.valid = validPassword.valid;
      }

      if (this.valid) return true;
    },
    login() {
      if (this.validateLogin()) {
        this.loading = true;
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            this.loading = false;
            this.$store.dispatch("INIT_USER").then(() => {
              this.$router.push({ name: "Index" });
            });
          })
          .catch(err => {
            console.log("Error: ", err);
          });
      }
    }
  }
};
</script>

<style lang="scss">
.login {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &__card {
    @include bp(sm) {
      padding: 5em;
      border-radius: 2.5em;
    }
    max-width: 35em;
    width: 100%;
    padding: 5em 2em;
    background: white;
    box-shadow: $shadow_sm;
    h2 {
      text-align: center;
      color: $lightred;
      margin-bottom: 2em;
    }
  }
}
</style>
